<template>
    <div>
      <el-dialog :title="title" :visible="carVisibleProp" width="996px" top="15%" @close="onClose">
          <el-form label-width="110px" :inline="true" size="mini">
                   <el-form-item size="mini" label="车牌号" prop="keywords">
                       <el-input v-model="keywords"/>
                   </el-form-item>
                  <el-button @click="chooseCar" size="mini">查询</el-button>
           </el-form>
          <div>
              <el-table
                      ref="multipleTable"
                      :data="mList"
                      height="300"
                      stripe
                      border
                      size="mini"
                      :header-cell-style="{background:'#e5e5e5',color:'#333333'}">
                  <el-table-column label="" width="50" align="center">
                      <template slot-scope="scope">
                          <el-radio v-model="currM" :label="scope.row" @input="clickChange(scope.row)">{{ "" }}</el-radio>
                      </template>
                  </el-table-column>
                  <el-table-column
                          label="车牌号"
                          width="105"
                          prop="plate_number"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                          label="车辆类型"
                          width="120"
                          prop="vehicle_type"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                          label="品牌型号"
                          width="130"
                          prop="model"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                          label="使用性质"
                          width="110"
                          prop="use_character"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>

                  <el-table-column
                          label="车辆所有人"
                          prop="allPerson"
                          :show-overflow-tooltip='true'
                  >
                  </el-table-column>
                  <el-table-column
                      label="车架号"
                      prop="vin"
                      :show-overflow-tooltip='true'
                  >
                  </el-table-column>
              </el-table>
              <el-row>
                  <el-col style="padding-top: 10px;display:flex;flex-direction: row;justify-content: flex-end;">
                      <el-button size="mini" @click="close">取消</el-button>
                      <el-button  size="mini" type="primary" @click="ok">确定</el-button>
                  </el-col>
              </el-row>
          </div>
      </el-dialog>
    </div>
</template>
<script>
  export default {
     name:'eCar',
     props:{
         carVisibleProp:{
             type:Boolean,
             default:false
         }
     },
     data(){
       return {
           keywords:'',
           car_number:'',
           currM:'-1',
           mList:[],
           total:0,
           title:'车辆选择',
           plate_number:'',
           car_id:'',
           vehicle_type:'',
           allPerson:'',
           vin:'',
           shop_id:'',
           fileList:[],
           credit_code:'',
           engine_number:'',
           mobile:''
       }
     },
      created() {
         this.getCarList();
      },
      methods:{
          clickChange(row){
              this.plate_number=row.plate_number;
              this.car_id=row.id;
              this.vehicle_type=row.vehicle_type;
              this.allPerson=row.allPerson;
              this.vin=row.vin;
              this.shop_id=row.shop_id;
              this.credit_code= row.shop.credit_code;
              this.engine_number=row.engine_number; //车架号
              this.mobile=row.mobile;//电话
          },
        getCarList(){
            const param = {
                company_id:sessionStorage.getItem('company_id'),
                access_token:sessionStorage.getItem('token'),
            }
            if(this.keywords){
                param.queryParams=this.keywords;
            }
            this.$axios.carFilesList(param).then(res=>{
                if(res.code == 200){
                    this.mList = res.data.data
                    this.total = res.data.total
                }else{
                  this.$message.error(res.msg);
                }
            }).catch(error=>{
                //console.log(error);
            })
        },
        onClose(){
             this.$emit('update:carVisibleProp',false)
        },
         close(){
             this.$emit('update:carVisibleProp',false)
         },
        ok(){
            this.$emit('eventCar',this.plate_number,this.car_id,this.vehicle_type,this.allPerson,this.vin,this.shop_id,this.credit_code,this.mobile);
            this.$emit('update:carVisibleProp',false)
        },
        handleBeforeUpload(){

        },
        uploadSuccess(){

        },
        uploadFile(){

        },
       chooseCar(){
           this.mList=[];
           this.getCarList();
         //this.$emit('eventCar',this.plate_number,this.car_id);
       }
    }
  }
</script>
<style lang="less" scoped>
    //https://www.yzktw.com.cn/post/1262748.html
    .upload_group {
        width: 100%;
        display: flex;
        justify-content: flex-start;
        align-items: center;

    .upload_list {
        width: 120px;
        margin-right: 1rem;
    }

    /deep/.el-upload-dragger .el-upload__text {
        font-size: 10px;
        color: #409EFF;
    }

    /deep/.el-icon-upload:before {
        width: 40px !important;
        height: 40px !important;
    }

    .upload_list:last-child {
        margin-right: 0;
    }

    /deep/.el-upload-dragger {
        width: 100%;
        height: auto;
        padding: 20px 0;
        border: 1px solid #999;
    }

    /deep/.el-upload {
        width: 100%;
    }

    /deep/.el-upload-dragger .el-icon-upload {
        margin: 10px 0;
    }
    }
    .table_name:hover{
        color: #409EFF;
        cursor: pointer;
    }
</style>



// WEBPACK FOOTER //
// src/view/common/eCar.vue